<template>
  <section id="insurance">
    <container class="pt-2 pb-16">
      
      <text-h2 class="text-center text-2xl mt-10">We Accept Insurance</text-h2>
      <div class="flex justify-center">
        <ul
          role="list"
          class="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3"
        >
          <li
            v-for="insurer in insurers"
            :key="insurer.name"
            class="col-span-1 flex"
          >
            <div class="flex flex-1 items-center justify-between truncate r">
              <div class="flex-1 truncate px-4 py-2 text-sm">
                <img v-if="typeof insurer.logo === 'string'" :src="insurer.logo" :alt="insurer.name" class="w-28 md:w-40" />
                <component v-else :is="insurer.logo" :class="insurer.name === 'Empire Blue Cross' ? 'w-20 md:w-28' : 'w-28 md:w-40'" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </container>
  </section>
</template>

<script setup>
import Aetna from "~/assets/images/providers/aetna.svg";
import BlueCross from "~/assets/images/providers/blue-cross.svg";
import Cigna from "~/assets/images/providers/cigna.svg";
import EmpireBlueCross from "~/assets/images/providers/empire-blue-cross.svg";
import Medicare from "~/assets/images/providers/medicare.svg";
import Oxford from "~/assets/images/providers/oxford.svg";
import Tricare from "~/assets/images/providers/tricare.svg";
import UnitedHealthCare from "~/assets/images/providers/united.svg";
import UnitedHealthcareCommunityPlan from "~/assets/images/providers/united-healthcare-community-plan.png";
// United Healthcare Community Plan will use PNG image

const insurers = [
  {
    name: "Aetna",
    logo: Aetna,
  },
  {
    name: "Blue Cross",
    logo: BlueCross,
  },
  {
    name: "Cigna",
    logo: Cigna,
  },
  {
    name: "Empire Blue Cross",
    logo: EmpireBlueCross,
  },
  {
    name: "Medicare",
    logo: Medicare,
  },
  {
    name: "Oxford",
    logo: Oxford,
  },
  {
    name: "Tricare",
    logo: Tricare,
  },
  {
    name: "United Health Care",
    logo: UnitedHealthCare,
  },
  {
    name: "United Healthcare Community Plan",
    logo: UnitedHealthcareCommunityPlan,
  },
];
</script>
